export default "__VITE_ASSET__BPMx5I70__"